module.exports = __webpack_public_path__ + "static/img/image13.cd906242.png";